"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexGrowFastRule = void 0;
exports.isIndexGrowingFast = isIndexGrowingFast;
const utils_1 = require("@azimutt/utils");
const common_1 = require("../../common");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const bytes_1 = require("../../helpers/bytes");
const date_1 = require("../../helpers/date");
const duration_1 = require("../../helpers/duration");
const percent_1 = require("../../helpers/percent");
const rule_1 = require("../rule");
const ruleId = 'index-grow-fast';
const ruleName = 'fast growing index';
const ruleDescription = 'indexes with rows or bytes growing over the daily/monthly/yearly rate thresholds and a size over the thresholds also';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.ConstraintId.array().optional(),
    minSize: bytes_1.Bytes,
    maxGrowthYearly: common_1.Percent,
    maxGrowthMonthly: common_1.Percent,
    maxGrowthDaily: common_1.Percent,
}).strict().describe('IndexGrowFastConf');
exports.indexGrowFastRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium, minSize: 10 * bytes_1.Mo, maxGrowthYearly: 2, maxGrowthMonthly: 0.1, maxGrowthDaily: 0.01 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && r.extra?.index?.name ? { ...r.entity, constraint: r.extra.index.name } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.constraintRefFromId) || []);
        const historyEntitiesById = history.map(h => ({ report: h.report, date: h.date, entities: (0, utils_1.indexBy)(h.database.entities || [], databaseUtils_1.entityToId) }));
        return (db.entities || [])
            .flatMap(e => (e.indexes || []).map(i => ({ entity: e, index: i })))
            .filter(({ entity, index: { name } }) => !(name && ignores.some(i => (0, databaseUtils_1.constraintRefSame)(i, { ...(0, databaseUtils_1.entityToRef)(entity), constraint: name }))))
            .map(e => {
            const previous = historyEntitiesById.map(h => {
                const entity = h.entities[(0, databaseUtils_1.entityToId)(e.entity)];
                const index = entity ? entity.indexes?.find(i => i.name === e.index.name) : undefined;
                return entity && index ? { report: h.report, date: h.date, value: { entity, index } } : undefined;
            }).filter(utils_1.isNotUndefined);
            return isIndexGrowingFast(now, e, previous, conf.minSize, conf.maxGrowthYearly, conf.maxGrowthMonthly, conf.maxGrowthDaily);
        })
            .filter(utils_1.isNotUndefined)
            .map(r => {
            const name = `${r.current.index.name}(${r.current.index.attrs.map(databaseUtils_1.attributePathToId).join(', ')}) on ${(0, databaseUtils_1.entityToId)(r.current.entity)}`;
            const rate = r.period > duration_1.oneYear ? ` (${(0, percent_1.showPercent)(r.yearly)} yearly)` : r.period > duration_1.oneMonth ? ` (${(0, percent_1.showPercent)(r.monthly)} monthly)` : r.period > duration_1.oneDay ? ` (${(0, percent_1.showPercent)(r.daily)} daily)` : '';
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Index ${name} has grown by ${(0, percent_1.showPercent)(r.growth)} (${(0, bytes_1.showBytes)(r.diff)}) since ${(0, date_1.showDate)(r.date)}${rate}.`,
                entity: (0, databaseUtils_1.entityToRef)(r.current.entity),
                extra: (0, utils_1.removeUndefined)({
                    previousReport: r.report,
                    previousDate: new Date(r.date).toISOString(),
                    periodMillis: r.period,
                    growth: r.growth,
                    previous: r.previous.index.stats,
                    current: r.current.index.stats,
                })
            };
        });
    }
};
function isIndexGrowingFast(now, current, history, minSize, maxGrowthYearly, maxGrowthMonthly, maxGrowthDaily) {
    const { size } = current.index.stats || {};
    if (size && size > minSize) {
        const fastGrowing = history.map(h => {
            const hSize = h.value.index.stats?.size;
            const growth = hSize && size > hSize ? { value: size - hSize, percent: (0, percent_1.computePercent)(hSize, size) } : undefined;
            if (growth) {
                const period = now - h.date;
                const daily = growth.percent / (period / duration_1.oneDay);
                const monthly = growth.percent / (period / duration_1.oneMonth);
                const yearly = growth.percent / (period / duration_1.oneYear);
                if ((period > duration_1.oneDay && daily > maxGrowthDaily) || (period > duration_1.oneMonth && monthly > maxGrowthMonthly) || (period > duration_1.oneYear && yearly > maxGrowthYearly)) {
                    return { date: h.date, report: h.report, current, previous: h.value, diff: growth.value, growth: growth.percent, period, daily, monthly, yearly };
                }
            }
        }).filter(utils_1.isNotUndefined);
        return (0, utils_1.maxBy)(fastGrowing, g => g.monthly);
    }
    return undefined;
}
//# sourceMappingURL=indexGrowFast.js.map